export const emits = {
  AFTER_LOAD_STADIUM: 'event:after-load-stadium',
  TAP_ON_SECTOR: 'event:tap-on-sector',
  AFTER_LOAD_SECTOR: 'event:after-load-sector',
  TAP_ON_PLACE: 'event:tap-on-place',
};
